import hres6euLabels from 'assets/labels/hres6eu'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6euLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number(),
        dtework: moment().format('DD/MM/YYYY'),
        typwrk_codshift_o: 'W,D1',
        typwrkr_codshiftr_o: '',
        typwrk_codshift_n: 'H,D1',
        typwrkr_codshiftr_n: '',
        staappr: staappr,
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dtework: moment().format('DD/MM/YYYY'),
      typwrko: 'W,D1',
      typwrkn: 'H,D2',
      codshifto: faker.lorem.word(),
      desc_codshifto: faker.lorem.word(),
      codshiftn: faker.lorem.word(),
      desc_codshiftn: faker.lorem.word(),
      timstrtwoe: moment().format('HH:mm'),
      timendwoe: moment().format('HH:mm'),
      timstrtwe: moment().format('HH:mm'),
      timendwe: moment().format('HH:mm'),
      typwrkro: 'W,D1',
      typwrkrn: 'H,D2',
      codshifro: faker.lorem.word(),
      desc_codshifro: faker.lorem.word(),
      codshifrn: faker.lorem.word(),
      desc_codshifrn: faker.lorem.word(),
      timstrtwor: moment().format('HH:mm'),
      timendwor: moment().format('HH:mm'),
      timstrtwr: moment().format('HH:mm'),
      timendwr: moment().format('HH:mm'),
      remark: faker.lorem.words()
    }
    let mockTab2 = {
    }

    return {
      tab1: mockTab1,
      tab2: mockTab2
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6eu/mocker.js